module.exports = __webpack_public_path__ + "static/img/ip@2x.2cb69625.png";